import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useRef, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import Icon from "noood/comp/ui/feather-icon/Icon";
import { form_validator } from "noood/comp/form/FormFieldValidator";
import { styling } from "noood/styles/styles.stylex";
import { FormContext } from "noood/contexts/contexts";
import OptionPickerPopover from './OptionPickerPopover';
import Text from "noood/comp/text/Text";
import { ArrayUtil } from "noood/util/array/ArrayUtil";
import { _get } from "noood/net/xhr";
import SpinnerApple from "noood/comp/ui/spinner/Spinner.Apple";
export default function OptionPicker(props) {
  var _props$validations, _formCtx$formObj2, _props$styling, _props$styling2, _props$styling3, _props$placeholder, _props$styling4;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    chosenOption = _useState2[0],
    setChosenOption = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    pickButtonIsActive = _useState4[0],
    setPickButtonIsActive = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    popoverElt = _useState6[0],
    setPopoverElt = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    finalList = _useState8[0],
    setFinalList = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    multipleOptionsSelected = _useState0[0],
    setMultipleOptionsSelected = _useState0[1];
  var _useState1 = useState(),
    _useState10 = _slicedToArray(_useState1, 2),
    isLoading = _useState10[0],
    setIsLoading = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    isDisabled = _useState12[0],
    setIsDisabled = _useState12[1];
  var optionRef = useRef();
  var formCtx = useContext(FormContext);
  var isRequired = ((_props$validations = props.validations) === null || _props$validations === void 0 ? void 0 : _props$validations.indexOf("required")) > -1;
  useEffect(function () {
    var _formCtx$formObj;
    var v = formCtx === null || formCtx === void 0 || (_formCtx$formObj = formCtx.formObj) === null || _formCtx$formObj === void 0 ? void 0 : _formCtx$formObj[props.name];
    if (props.multiple) {} else {
      if (v && (finalList !== null && finalList !== void 0 ? finalList : props.options)) {
        var _ref;
        var finalOption = (_ref = finalList !== null && finalList !== void 0 ? finalList : props.options) === null || _ref === void 0 ? void 0 : _ref.find(function (o) {
          return String(o.value) === String(v);
        });
        setChosenOption(finalOption);
      } else {
        setChosenOption(undefined);
      }
    }
  }, [formCtx === null || formCtx === void 0 || (_formCtx$formObj2 = formCtx.formObj) === null || _formCtx$formObj2 === void 0 ? void 0 : _formCtx$formObj2[props.name], props.options]);
  useEffect(function () {
    if (props.endpoint_source) {
      setIsLoading(true);
      setIsDisabled(true);
      _get(props.endpoint_source, function (res) {
        var _res$http;
        setIsLoading(false);
        setIsDisabled(false);
        if (((_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 200 && res.data) {
          setFinalList(res.data);
        }
      });
    }
  }, [props.endpoint_source]);
  useEffect(function () {
    var _formCtx$formObj3;
    var v = formCtx === null || formCtx === void 0 || (_formCtx$formObj3 = formCtx.formObj) === null || _formCtx$formObj3 === void 0 ? void 0 : _formCtx$formObj3[props.name];
    if (v && (finalList !== null && finalList !== void 0 ? finalList : props.options)) {
      var _ref2;
      setChosenOption((_ref2 = finalList !== null && finalList !== void 0 ? finalList : props.options) === null || _ref2 === void 0 ? void 0 : _ref2.find(function (o) {
        return String(o.value) === String(v);
      }));
    } else {
      setChosenOption(undefined);
    }
  }, [finalList]);
  var __startPicking = function __startPicking(e) {
    if (!(props.disabled || isDisabled)) {
      var _e$target;
      if (chosenOption && ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.tagName) === "I") {
        var _formCtx$__collect;
        formCtx === null || formCtx === void 0 || (_formCtx$__collect = formCtx.__collect) === null || _formCtx$__collect === void 0 || _formCtx$__collect.call(formCtx, props.name, undefined, form_validator.validate(props.validations, undefined));
        setPopoverElt(undefined);
      } else {
        setPickButtonIsActive(true);
        setPopoverElt(/*#__PURE__*/React.createElement(OptionPickerPopover, {
          __onClose: function __onClose() {
            var _optionRef$current, _optionRef$current$bl;
            setPopoverElt(undefined);
            setPickButtonIsActive(false);
            optionRef === null || optionRef === void 0 || (_optionRef$current = optionRef.current) === null || _optionRef$current === void 0 || (_optionRef$current$bl = _optionRef$current.blur) === null || _optionRef$current$bl === void 0 || _optionRef$current$bl.call(_optionRef$current);
          },
          canFilter: props.canFilter,
          sender: optionRef.current,
          list: finalList !== null && finalList !== void 0 ? finalList : props.options,
          optionsContainerMinimumWidth: props.optionsContainerMinimumWidth,
          multipleOptionsSelected: multipleOptionsSelected,
          multiple: props.multiple,
          currentChosenOption: chosenOption,
          __pick: function __pick(chosenOption) {
            if (props.multiple) {
              var _formCtx$__collect2, _props$__multipleSele;
              var cloneOfOptionsSelected = _toConsumableArray(multipleOptionsSelected !== null && multipleOptionsSelected !== void 0 ? multipleOptionsSelected : []);
              console.log("cloneOfOptionsSelected: ", cloneOfOptionsSelected);
              var indexOfChosenFromSelectedList = ArrayUtil.array_find_index(cloneOfOptionsSelected, 'value', chosenOption.value);
              console.log("indexOfChosenFromSelectedList: ", indexOfChosenFromSelectedList);
              if (indexOfChosenFromSelectedList > -1) {
                cloneOfOptionsSelected.splice(indexOfChosenFromSelectedList, 1);
                if ((cloneOfOptionsSelected === null || cloneOfOptionsSelected === void 0 ? void 0 : cloneOfOptionsSelected.length) > 0) {
                  var lastRecord = cloneOfOptionsSelected[cloneOfOptionsSelected.length - 1];
                  setChosenOption(lastRecord);
                } else {
                  setChosenOption(undefined);
                }
              } else {
                cloneOfOptionsSelected.push(chosenOption);
                setChosenOption(chosenOption);
              }
              setMultipleOptionsSelected(cloneOfOptionsSelected);
              formCtx === null || formCtx === void 0 || (_formCtx$__collect2 = formCtx.__collect) === null || _formCtx$__collect2 === void 0 || _formCtx$__collect2.call(formCtx, props.name, cloneOfOptionsSelected.map(function (opt) {
                return opt.value;
              }), form_validator.validate(props.validations, cloneOfOptionsSelected.map(function (opt) {
                return opt.value;
              })));
              (_props$__multipleSele = props.__multipleSelection) === null || _props$__multipleSele === void 0 || _props$__multipleSele.call(props, cloneOfOptionsSelected);
            } else {
              var _optionRef$current2, _optionRef$current2$b, _props$__pick, _formCtx$__collect3;
              setChosenOption(chosenOption);
              optionRef === null || optionRef === void 0 || (_optionRef$current2 = optionRef.current) === null || _optionRef$current2 === void 0 || (_optionRef$current2$b = _optionRef$current2.blur) === null || _optionRef$current2$b === void 0 || _optionRef$current2$b.call(_optionRef$current2);
              (_props$__pick = props.__pick) === null || _props$__pick === void 0 || _props$__pick.call(props, chosenOption);
              formCtx === null || formCtx === void 0 || (_formCtx$__collect3 = formCtx.__collect) === null || _formCtx$__collect3 === void 0 || _formCtx$__collect3.call(formCtx, props.name, chosenOption === null || chosenOption === void 0 ? void 0 : chosenOption.value, form_validator.validate(props.validations, chosenOption === null || chosenOption === void 0 ? void 0 : chosenOption.value));
            }
            setPopoverElt(undefined);
            setPickButtonIsActive(false);
          }
        }));
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "OptionPicker__ui.container ev78zum5 evdt5ytf evh8yej3"
  }, props.label && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: isDisabled || props.disabled ? 'var(--shade-10)' : 'var(--text-color)'
  }, props.label)), /*#__PURE__*/React.createElement("div", _extends({
    ref: optionRef
  }, stylex.props(ui.base, isRequired && ui.required, isRequired && ui.required_border, (props.disabled || isDisabled) && ui.disabled, pickButtonIsActive && ui.is_picking), {
    style: (_props$styling = props.styling) === null || _props$styling === void 0 ? void 0 : _props$styling.box,
    onClick: function onClick(e) {
      __startPicking(e);
    },
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.code === "Tab" && e.shiftKey) {
        optionRef.current.blur();
      }
      if (props.showOptionsOnSpacebar && e.code == "Space") {
        __startPicking(e);
      } else {
        if (props.showOptionsOnFocus !== false) {
          __startPicking(e);
        }
      }
    }
  }), props.icon && /*#__PURE__*/React.createElement("div", {
    className: "OptionPicker__ui.icon_box ev78zum5 ev6s0dn4 evl56j7k"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    color: isRequired ? props.disabled || isDisabled ? "var(--shade-10)" : "var(--text-on-required-secondary)" : props.disabled || isDisabled ? "var(--shade-10)" : "var(--shade-70)"
  })), /*#__PURE__*/React.createElement("div", stylex.props(ui.content, styling.with_ellipsis), chosenOption && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({
      flex: 1
    }, (_props$styling2 = props.styling) === null || _props$styling2 === void 0 ? void 0 : _props$styling2.current_chosen_text)
  }, /*#__PURE__*/React.createElement(Text, {
    color: props.disabled || isDisabled ? 'var(--shade-20)' : isRequired ? "var(--text-on-required)" : 'var(--text-color)'
  }, chosenOption.code)), (multipleOptionsSelected === null || multipleOptionsSelected === void 0 ? void 0 : multipleOptionsSelected.length) > 1 && /*#__PURE__*/React.createElement("div", {
    className: "OptionPicker__ui.more_selected_counter ev17z2i9w evmix8c7 evwnonoy ev1tzx33q ev1j6dyjg ev1m3ak92 ev78zum5 ev6s0dn4 evl56j7k"
  }, "+", multipleOptionsSelected.length - 1)), chosenOption === void 0 && /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.choose_placeholder, isRequired && ui.text_on_required_secondary, (props.disabled || isDisabled) && styling.muted_text), {
    style: _objectSpread({}, (_props$styling3 = props.styling) === null || _props$styling3 === void 0 ? void 0 : _props$styling3.current_chosen_text)
  }), (_props$placeholder = props.placeholder) !== null && _props$placeholder !== void 0 ? _props$placeholder : "Choose...")), (props.isLoading || isLoading) && /*#__PURE__*/React.createElement("div", {
    className: "OptionPicker__ui.loading ev78zum5 ev6s0dn4 evl56j7k ev14odnwx"
  }, /*#__PURE__*/React.createElement(SpinnerApple, null)), !props.isLoading && /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.pick_button, chosenOption && ui.clear_button, (props.disabled || isDisabled) && ui.pick_disabled), {
    onClick: function onClick(e) {
      if (!(props.disabled || isDisabled)) {
        if (chosenOption) {
          var _props$__pick2, _props$__multipleSele2;
          setChosenOption(undefined);
          setMultipleOptionsSelected(undefined);
          (_props$__pick2 = props.__pick) === null || _props$__pick2 === void 0 || _props$__pick2.call(props, undefined);
          (_props$__multipleSele2 = props.__multipleSelection) === null || _props$__multipleSele2 === void 0 || _props$__multipleSele2.call(props, undefined);
          setPopoverElt(undefined);
        } else {
          __startPicking(e);
        }
      }
    },
    style: (_props$styling4 = props.styling) === null || _props$styling4 === void 0 ? void 0 : _props$styling4.pick_button
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: chosenOption ? "x" : "chevron-down",
    color: props.disabled || isDisabled ? "var(--shade-10)" : "".concat(isRequired ? 'var(--text-on-required)' : 'var(--shade-30)')
  }))), popoverElt);
}
OptionPicker.displayName = '__option_picker';

// @ts-ignore
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1tgzv6z{height:var(--field-height)}", 4000);
_inject(".ev13a6bvl{justify-content:flex-end}", 3000);
_inject(".ev1qjc9v5{align-items:stretch}", 3000);
_inject(".ev1nejdyq{gap:5px}", 2000);
_inject(".evcpk43y{padding-left:5px}", 4000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".evmkeg23{border-width:1px}", 2000);
_inject(".ev1y0btm7{border-style:solid}", 2000);
_inject(".evc5895u{border-color:var(--shade-30)}", 2000);
_inject(".ev1lko15j{background-color:var(--shade-required)}", 3000);
_inject(".ev17e5z5g{color:var(--text-color)}", 3000);
_inject(".evezl2tj{width:25px}", 4000);
_inject(".eve0pwq{border-left-width:1px}", 4000);
_inject(".ev19ypqd9{border-left-style:solid}", 4000);
_inject(".ev1gyf37z{border-left-color:var(--shade-30)}", 4000);
_inject(".evor0oh0{border-top-right-radius:var(--roundness)}", 4000);
_inject(".evzap5uf{border-bottom-right-radius:var(--roundness)}", 4000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".evx0v439{transition:background-color .2s ease,padding-top .1s}", 2000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".evexx8yu{padding-top:0}", 4000);
_inject(".evv9n51f:active{padding-top:2px}", 4170);
_inject(".ev98rzlu{flex:1}", 2000);
_inject(".evr9ek0c{margin-top:2px}", 4000);
_inject(".evdt5ytf{flex-direction:column}", 3000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".ev1h6gzvc{cursor:not-allowed}", 3000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".evgih7pf{border-color:var(--shade-05)}", 2000);
_inject(".evfp6sjc{border-left-color:var(--shade-05)}", 4000);
_inject(".evlyipyv{text-overflow:ellipsis}", 3000);
_inject(".evuxw1ft{white-space:nowrap}", 3000);
_inject(".evb3r6kr{overflow:hidden}", 2000);
_inject(".evytml03{color:var(--shade-50)}", 3000);
_inject(".ev1kijww5{border-color:var(--shade-required-border)}", 2000);
_inject(".evip966{color:var(--text-on-required)}", 3000);
_inject(".ev7u93xe{color:var(--text-on-required-secondary)}", 3000);
_inject(".evfrllxf{border-bottom-left-radius:0}", 4000);
_inject(".evjppbhk{border-bottom-right-radius:0}", 4000);
_inject(".ev17z2i9w{width:22px}", 4000);
_inject(".evmix8c7{height:18px}", 4000);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
_inject(".ev1tzx33q{color:var(--text-on-accent)}", 3000);
_inject(".ev1j6dyjg{font-size:11px}", 3000);
_inject(".ev1m3ak92{border-radius:20px}", 2000);
_inject(".ev14odnwx{padding:5px}", 1000);
var ui = {
  base: {
    "OptionPicker__ui.base": "OptionPicker__ui.base",
    backgroundColor: "evji57aj",
    display: "ev78zum5",
    height: "ev1tgzv6z",
    justifyContent: "ev13a6bvl",
    alignItems: "ev1qjc9v5",
    gap: "ev1nejdyq",
    rowGap: null,
    columnGap: null,
    paddingLeft: "evcpk43y",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "evc5895u",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  required: {
    "OptionPicker__ui.required": "OptionPicker__ui.required",
    backgroundColor: "ev1lko15j",
    color: "ev17e5z5g",
    $$css: true
  },
  pick_button: {
    "OptionPicker__ui.pick_button": "OptionPicker__ui.pick_button",
    width: "evezl2tj",
    borderLeftWidth: "eve0pwq",
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    borderLeftStyle: "ev19ypqd9",
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    borderLeftColor: "ev1gyf37z",
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    display: "ev78zum5",
    borderTopRightRadius: "evor0oh0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderBottomRightRadius: "evzap5uf",
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    alignItems: "ev6s0dn4",
    justifyContent: "evl56j7k",
    transition: "evx0v439",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "evjbqb8w ev3dtjww",
    paddingTop: "evexx8yu evv9n51f",
    $$css: true
  },
  content: {
    "OptionPicker__ui.content": "OptionPicker__ui.content",
    display: "ev78zum5",
    alignItems: "ev6s0dn4",
    flex: "ev98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    $$css: true
  },
  disabled: {
    "OptionPicker__ui.disabled": "OptionPicker__ui.disabled",
    cursor: "ev1h6gzvc",
    backgroundColor: "ev1y7ric0",
    borderColor: "evgih7pf",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  pick_disabled: {
    "OptionPicker__ui.pick_disabled": "OptionPicker__ui.pick_disabled",
    paddingTop: "evexx8yu",
    backgroundColor: "evjbqb8w",
    borderLeftColor: "evfp6sjc",
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    $$css: true
  },
  choose_placeholder: {
    "OptionPicker__ui.choose_placeholder": "OptionPicker__ui.choose_placeholder",
    textOverflow: "evlyipyv",
    whiteSpace: "evuxw1ft",
    overflow: "evb3r6kr",
    overflowX: null,
    overflowY: null,
    color: "evytml03",
    $$css: true
  },
  required_border: {
    "OptionPicker__ui.required_border": "OptionPicker__ui.required_border",
    borderColor: "ev1kijww5",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  text_on_required_secondary: {
    "OptionPicker__ui.text_on_required_secondary": "OptionPicker__ui.text_on_required_secondary",
    color: "ev7u93xe",
    $$css: true
  },
  is_picking: {
    "OptionPicker__ui.is_picking": "OptionPicker__ui.is_picking",
    borderBottomLeftRadius: "evfrllxf",
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderBottomRightRadius: "evjppbhk",
    $$css: true
  }
};